import React from "react";
import "./FreeTag.css";

const FreeTag = () => {
    return <div className="free-tag">FREE</div>;
};

export default FreeTag;